import { axiosInstance } from "./axios";
import type {
  FBUser,
  FBSession,
  FBGroup,
  FBMixtape,
  FBTeam,
  FBOrg,
} from "./types";

export const fetchUser = async (userId: string): Promise<FBUser> => {
  return axiosInstance
    .get(`/public/user/${userId}`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchUser`:", err);
      throw err;
    });
};

export const fetchSession = async (sessionId: string): Promise<FBSession> => {
  return axiosInstance
    .get(`/public/session/${sessionId}`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchSession`:", err);
      throw err;
    });
};

export const fetchSessionOwner = async (sessionId: string): Promise<FBUser> => {
  return axiosInstance
    .get(`/public/session/${sessionId}/owner`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchSessionOwner`:", err);
      throw err;
    });
};

export const fetchGroup = async (groupId: string): Promise<FBGroup> => {
  return axiosInstance
    .get(`/public/group/${groupId}`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchGroup`:", err);
      throw err;
    });
};

export const fetchGroupOwner = async (groupId: string): Promise<FBUser> => {
  return axiosInstance
    .get(`/public/group/${groupId}/owner`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchGroupOwner`:", err);
      throw err;
    });
};

export const fetchTeam = async (teamId: string): Promise<FBTeam> => {
  return axiosInstance
    .get(`/public/team/${teamId}`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchTeam`:", err);
      throw err;
    });
};

export const fetchTeamOwner = async (teamId: string): Promise<FBUser> => {
  return axiosInstance
    .get(`/public/team/${teamId}/owner`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchTeamOwner`:", err);
      throw err;
    });
};

export const fetchOrg = async (orgId: string): Promise<FBOrg> => {
  return axiosInstance
    .get(`/public/org/${orgId}`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchTeam`:", err);
      throw err;
    });
};

export const fetchOrgOwner = async (orgId: string): Promise<FBUser> => {
  return axiosInstance
    .get(`/public/org/${orgId}/owner`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchOrgOwner`:", err);
      throw err;
    });
};

export const fetchMixtape = async (mixtapeId: string): Promise<FBMixtape> => {
  return axiosInstance
    .get(`/public/mixtape/${mixtapeId}`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchMixtape`:", err);
      throw err;
    });
};

export const fetchMixtapeOwner = async (mixtapeId: string): Promise<FBUser> => {
  return axiosInstance
    .get(`/public/mixtape/${mixtapeId}/owner`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchMixtapeOwner`:", err);
      throw err;
    });
};

export const fetchReferralMeta = async (
  referralCode: string
): Promise<{ username: string; title: string; description: string } | null> => {
  return axiosInstance
    .get(`/referrals/meta/${referralCode}`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in `fetchReferralMeta`:", err);
      return null;
    });
};
